<template>
  <div>
    <h1 class="title">{{ $t('settings.settingTitle') }}</h1>
    <div class="main-settings">
      <div class="settings-section">
        <h2 class="sub-title">{{ $t('settings.officeHeader') }}</h2>
        <office-dropdown
          :disabled="!user.isWizeliner"
          :selected="user.office"
          @change="onOfficeSelected"
        />
      </div>
      <div class="settings-section">
        <h2 class="sub-title">{{ $t('settings.dietTypeHeader') }}</h2>
        <div>
          <checkbox-group :display-description="true" @checked="onDietChecked" />
        </div>
      </div>
      <div class="settings-section">
        <h2 class="sub-title">{{ $t('settings.allergiesHeader') }}</h2>
        <allergy-selector :selected="selectedAllergies" @change="onAllergiesChanged" />
      </div>
      <div class="save-button">
        <common-button primary @click="saveButtonClick">
          {{ $t('settings.saveButton') }}
        </common-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import difference from 'lodash.difference';
import OfficeDropdown from '@/components/OfficeDropdown';
import CheckboxGroup from '@/components/CheckboxGroup';
import AllergySelector from '@/components/AllergySelector';
import CommonButton from '@/components/common/CommonButton';

export default {
  name: 'Settings',
  components: {
    CheckboxGroup,
    OfficeDropdown,
    AllergySelector,
    CommonButton,
  },
  data() {
    return {
      dietsChecked: [],
      officeSelected: '',
      allergies: [],
    };
  },
  computed: {
    ...mapGetters('user', { user: 'getUser' }),
    selectedAllergies() {
      return this.user.allergiesInfo.map((a) => a.id);
    },
  },
  methods: {
    ...mapActions('user', {
      updateUsersOffice: 'updateUsersOffice',
      setUsersAllergies: 'setUsersAllergies',
    }),
    onDietChecked(value) {
      this.dietsChecked = value;
    },
    onOfficeSelected(officeId) {
      this.officeSelected = officeId;
      this.updateUsersOffice(officeId);
    },
    onAllergiesChanged(allergies) {
      this.allergies = allergies;
    },
    async saveButtonClick() {
      await this.setUsersAllergies(this.allergies);
      const dietsDifferenceChecked = difference(this.dietsChecked, this.user.dietsInfo);
      const dietsDifferenceUser = difference(this.user.dietsInfo, this.dietsChecked);
      if (
        dietsDifferenceChecked.length > 0 ||
        dietsDifferenceUser.length > 0 ||
        this.officeSelected !== this.user.office
      ) {
        this.displayMessage(this.$t('settings.messages.saveButtonSuccess'));
      } else {
        this.displayMessage(this.$t('settings.messages.saveButtonFail'));
      }
    },
    displayMessage(message) {
      this.$alert(message, {
        confirmButtonText: 'OK',
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';
.main-settings {
  text-align: left;
  margin-left: 50px;
  margin-top: 5px;
  width: auto;
}
.settings-section {
  padding-top: 5px;
  padding-bottom: 15px;
}
.save-button {
  padding: 20px;
}
.title {
  margin-left: 15px;
  font-weight: $bold-font;
  font-size: $title-font-size;
}
.sub-title {
  font-weight: $bold-font;
}
.title,
.sub-title {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/SettingsPage.vue